import { writable } from "svelte/store";

type MouseCoordinatesStore = {
    mouseCoordinates: {
        latitudePosition: string,
        longitudePosition: string
    }
};

const mouseCoordinatesStore = writable<MouseCoordinatesStore>({
    mouseCoordinates: {
        latitudePosition: "0",
        longitudePosition: "0"
    }
});

export {
    mouseCoordinatesStore
}